import React from 'react';
import { FaPlaneDeparture, FaHotel, FaUtensils, FaCamera, FaShuttleVan, FaTicketAlt, FaCar } from 'react-icons/fa';

interface InclusionIconsProps {
  inclusions: string[];
}

const iconMap: Record<string, React.ReactNode> = {
  flight: FaPlaneDeparture({ size: 24 }),
  flights: FaPlaneDeparture({ size: 24 }),
  hotel: FaHotel({ size: 24 }),
  hotels: FaHotel({ size: 24 }),
  meals: FaUtensils({ size: 24 }),
  sightseeing: FaCamera({ size: 24 }),
  transfers: FaShuttleVan({ size: 24 }),
  transfer: FaCar({ size: 24 }),
  activities: FaTicketAlt({ size: 24 }),
  activity: FaTicketAlt({ size: 24 }),
};

const labels: Record<string, string> = {
  flight: 'Flights',
  flights: 'Flights',
  hotel: 'Hotels',
  hotels: 'Hotels',
  meals: 'Meal',
  sightseeing: 'Sightseeing',
  transfers: 'Transfers',
  transfer: 'Transfers',
  activities: 'Activities',
  activity: 'Activities'
};

const InclusionIcons: React.FC<InclusionIconsProps> = ({ inclusions }) => (
  <div className="inclusion-icons">
    {inclusions.map(key => (
      <div key={key} className="inclusion-item">
        {iconMap[key] || <span style={{ fontSize: '24px' }}>📋</span>}
        <span>{labels[key] || key}</span>
      </div>
    ))}
  </div>
);

export default InclusionIcons;
